// All content for the homepage lives here, so prices, classes and links can be
// updated without touching the layout components.

const CHECKOUT = "https://checkout.joinmaat.com/?gymId=pablo_cerino_jiu_jitsu_school&priceId=";

export const contact = {
	phoneDisplay: "+32 (0) 494 18 13 63",
	phoneHref: "tel:+32494181363",
	email: "IconBrussels@gmail.com",
	instagram: "https://www.instagram.com/iconbjjbelgium/",
	facebook: "https://www.facebook.com/pablo.cerino.iconbjj",
	instagramHandle: "@IconBjjBelgium",
	addressLine1: "Rue Dodonée 70",
	addressLine2: "1180 Uccle, Belgium",
	mapsUrl: "https://goo.gl/maps/nNvJzYjVFfxirpat5",
};

export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// kind: gi | nogi | women | kids
export const schedule = {
	adults: [
		[
			{ time: "12:00", name: "BJJ · All levels", kind: "gi" },
			{ time: "18:00", name: "Women's only", kind: "women" },
			{ time: "19:00", name: "BJJ Basics", kind: "gi" },
			{ time: "20:00", name: "BJJ · Int / Adv", kind: "gi" },
		],
		[
			{ time: "07:30", name: "BJJ · All levels", kind: "gi" },
			{ time: "12:00", name: "NoGi · All levels", kind: "nogi" },
			{ time: "19:00", name: "BJJ · All levels", kind: "gi" },
			{ time: "20:00", name: "NoGi · All levels", kind: "nogi" },
		],
		[
			{ time: "07:30", name: "NoGi · All levels", kind: "nogi" },
			{ time: "12:00", name: "BJJ · All levels", kind: "gi" },
			{ time: "18:00", name: "Women's only", kind: "women" },
			{ time: "19:00", name: "BJJ Basics", kind: "gi" },
			{ time: "20:00", name: "BJJ · Int / Adv", kind: "gi" },
		],
		[
			{ time: "07:30", name: "BJJ · All levels", kind: "gi" },
			{ time: "12:00", name: "BJJ · All levels", kind: "gi" },
			{ time: "19:00", name: "BJJ · All levels", kind: "gi" },
			{ time: "20:00", name: "NoGi · All levels", kind: "nogi" },
		],
		[
			{ time: "12:00", name: "NoGi · All levels", kind: "nogi" },
			{ time: "19:00", name: "BJJ · to 20:30", kind: "gi" },
		],
		[{ time: "14:00", name: "BJJ · to 15:30", kind: "gi" }],
	],
	kids: [
		[{ time: "17:00", name: "Kids 9-12", kind: "kids" }],
		[
			{ time: "16:30", name: "Kids 3-6", kind: "kids" },
			{ time: "17:00", name: "Kids 9-12", kind: "kids" },
			{ time: "17:30", name: "Kids 6-12", kind: "kids" },
		],
		[
			{ time: "13:40", name: "Kids 3-6", kind: "kids" },
			{ time: "14:30", name: "Kids 6-9", kind: "kids" },
			{ time: "15:30", name: "Kids 9-12", kind: "kids" },
		],
		[
			{ time: "16:30", name: "Kids 3-6", kind: "kids" },
			{ time: "17:00", name: "Kids 9-12", kind: "kids" },
			{ time: "17:30", name: "Kids 6-12", kind: "kids" },
		],
		[{ time: "17:00", name: "Kids 9-12", kind: "kids" }],
		[
			{ time: "10:00", name: "Kids 3-6", kind: "kids" },
			{ time: "11:00", name: "Kids 6-9", kind: "kids" },
			{ time: "12:00", name: "Kids 9-12", kind: "kids" },
		],
	],
};

// Prices in euros. `priceId` is the Maat checkout price for each plan.
export const plans = [
	{
		id: "adults",
		label: "Adults",
		options: [
			{ period: "Month", price: 150, priceId: "price_1PqYYiP20CPU4adeBWrIK9X2" },
			{ period: "Trimester", price: 390, priceId: "price_1PqYZnP20CPU4adeCi8rCFRO" },
			{ period: "Semester", price: 690, priceId: "price_1PqYaDP20CPU4ade06b9rPhQ" },
			{ period: "Year", price: 1200, priceId: "price_1PqYapP20CPU4adep9KeNcn4", best: true },
		],
	},
	{
		id: "reduced",
		label: "Students & women",
		options: [
			{ period: "Month", price: 100, priceId: "price_1P42rmP20CPU4adetq6plLat" },
			{ period: "Trimester", price: 255, priceId: "price_1P42ptP20CPU4adeAbNFX9f3" },
			{ period: "Semester", price: 450, priceId: "price_1P42otP20CPU4adeDSXhQYuW" },
			{ period: "Year", price: 780, priceId: "price_1P42lYP20CPU4adev34BKBa0", best: true },
		],
	},
	{
		id: "women",
		label: "Women's only class",
		options: [
			{ period: "Month", price: 120, priceId: "price_1PvKozP20CPU4ademxtFwcTO" },
			{ period: "Trimester", price: 300, priceId: "price_1PvKrWP20CPU4ade1ylOgbUu" },
			{ period: "Semester", price: 500, priceId: "price_1PvKqVP20CPU4ade8DO7GBjK" },
			{ period: "Year", price: 900, priceId: "price_1PvKruP20CPU4ademcwiFoR7", best: true },
		],
	},
	{
		id: "kids",
		label: "Kids",
		options: [
			{ period: "Semester", price: 490, priceId: "price_1PqYcPP20CPU4adefOyGs5uJ" },
			{ period: "Year", price: 790, priceId: "price_1PqYd9P20CPU4adeapIDXf2O", best: true },
		],
	},
].map((plan) => ({
	...plan,
	options: plan.options.map((option) => ({
		...option,
		url: option.priceId ? CHECKOUT + option.priceId : "",
	})),
}));

export const faqs = [
	{
		q: "Do I need a Gi to start?",
		a: "No. Shorts and a t-shirt are fine for your first classes. You will want a Gi as you progress, since many techniques use it.",
	},
	{ q: "What should I bring?", a: "Shorts, a t-shirt, and cut finger and toenails." },
	{ q: "What is NoGi?", a: "Jiu-Jitsu without the Gi, in shorts and a tight shirt." },
	{
		q: "Is BJJ for women too?",
		a: "Absolutely. Many women train with us, and there is a women's only class on Monday and Wednesday.",
	},
	{
		q: "I don't like being punched or kicked. Is BJJ for me?",
		a: "Yes. There are no kicks or punches in BJJ; we only train how to defend against them.",
	},
	{
		q: "How long does it take to get a black belt?",
		a: "It's a long journey: you go through blue, purple and brown belt first.",
	},
	{ q: "Do you offer private classes?", a: "Yes. Call or email Pablo to arrange one." },
];
